import { useLocation, useNavigate } from "react-router-dom";

import { IStateOrigin } from "../../../navigators/navigateStateObjects";
import { AssetManagerSingleCardTemplate } from "../../../templates";
import { AssetManagerCompaniesListPage } from "./companies";

const Operations = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const stateOrigin = location.state?.origin as IStateOrigin | undefined;

  return (
    <AssetManagerSingleCardTemplate
      activeElement="Operations"
      pageTitle="CRM"
      handleBackClick={stateOrigin?.from ? () => navigate(stateOrigin.from) : undefined}
      backButtonText={stateOrigin?.goBackText}
    >
      <AssetManagerCompaniesListPage />
    </AssetManagerSingleCardTemplate>
  );
};

export default Operations;
